import { Object3D, ObjectLoader, Box3, BoxGeometry, MeshStandardMaterial, Mesh } from 'three';

/**
 * Wraps all model-related functionality
 * @class RevitModel
 */
class Model {
    /**
     * Creates an instance of RevitModel.
     * @memberof RevitModel
     */
    constructor(object3D) {
      this.object = object3D;
      this.pivot = new Object3D();
      this.pivot.add(this.object);
      // Compute bounding box for geometry-related operations
      // and bounding sphere for lights
      this.getBoundingFigures();
    }

    /**
     * Gets _boundingSphere value
     */
    get boundingSphere() {
        return this._boundingSphere;
    }

    /**
     * Sets _boundingSphere value
     */
    set boundingSphere(boundingSphere) {
        this._boundingSphere = boundingSphere;
    }

    /**
     * Gets _boundingBox value
     */
    get boundingBox() {
        return this._boundingBox;
    }

    /**
     * Sets _boundingBox value
     */
    set boundingBox(boundingBox) {
        this._boundingBox = boundingBox;
    }

    static load(scene) {
        if (scene && scene.object) {
          this.loader = this.loader || new ObjectLoader(); // a loader for loading a JSON resource
          return this.loader.parse(scene);
        }

        const boxSize = 250;
        var geometry = new BoxGeometry(boxSize, boxSize - 1, boxSize - 1);
        var material = new MeshStandardMaterial({ color: 0xb22222  });
        var cube = new Mesh(geometry, material);
        cube.castShadow = true; //default is false
        cube.receiveShadow = true; //default

        cube.traverse((geo) => {
          if (!(geo instanceof Mesh))
            return false;
          geo.geometry.translate(-boxSize / 2, boxSize / 2, -boxSize / 2);
          return true;
        });

        return cube;
    }

    /**
     * Loops over the children of the THREE scene, merge them into a mesh,
     * and compute a bounding sphere for the scene
     * @memberof RevitModel
     */
    getBoundingFigures() {
        this.boundingBox = new Box3().setFromObject(this.object);
        this.boundingSphere = new Box3().setFromObject(this.object).getBoundingSphere(this.boundingSphere);
        this.geometry = null;
    }
}

export { Model as default };
